'use strict';
export default class OPLMasthead {

    constructor() {

        this.mastheadImages = document.querySelectorAll('[data-opl-masthead-image]');

    }

    init() {

        const _self = this;

        // if there are mastheads proceed:
        if (_self.mastheadImages.length > 0) {
            // set the background image style
            _self.setBackgroundStyle();
            // add window resize event listener
            _self.setupListeners();
        }
    }

    setupListeners() {

        const _self = this;

        // change the background image depending on the screen size
        window.addEventListener(
            // listening for resize
            "resize",
            // use the custom debounce
            window.OPL.Utility.debounce(() => {
                // set the background image style
                _self.setBackgroundStyle();
            }, 200)
        );

    }

    // set the background styles based
    // on the screen width
    setBackgroundStyle() {

        const _self = this;

        // get the viewport element (HTML tag)
        const _win = document.querySelector('html');
        // for each masthead image set the 
        // background style based on the screen size
        _self.mastheadImages.forEach(masthead => {

            // get the image from the data attributes
            let img = masthead.dataset.oplMastheadImage;

            if (_win.clientWidth < 768) {
                img = masthead.dataset.oplMastheadImageMobile;
            }

            const style = `url('${img}')`;
            // if the background style is different, set it
            if (style != masthead.style.backgroundImage) {
                masthead.style.backgroundImage = `url('${img}')`;
            }

        });
    }
}
